import type { PinoLogger } from '@analytical-alley/common';
import { createConsole } from '../../utils';

export function createLogger(consoleEnabled: boolean): PinoLogger {
    const customConsole = createConsole(consoleEnabled);
    return {
        logger: {} as unknown as any,
        ...customConsole,
        fatal: customConsole.error,
        setContext() {},
        assign() {},
    };
}
